import Canvas from "ui/canvas/Canvas";
import {SCENE_FRAMES, SCENE_SOURCE_HEIGHT, SCENE_SOURCE_WIDTH} from "ui/config";
import Utils from "ui/helpers/Utils";
import CanvasClipArea from "ui/canvas/CanvasClipArea";
import CanvasLayer from "ui/canvas/CanvasLayer";

export default class SceneFlatter {
	/**
	 * @param {T_CanvasData} data
	 * @returns {Promise<T_CanvasData>}
	 */
	async flatCanvasData(data) {
		const canvas = new Canvas({
			sceneWidth: SCENE_SOURCE_WIDTH,
			sceneHeight: SCENE_SOURCE_HEIGHT,
			frames: SCENE_FRAMES
		});
		canvas.setData(data);
		const layers = canvas.getLayers();
		const srcClip = new CanvasClipArea(SCENE_SOURCE_WIDTH, SCENE_SOURCE_HEIGHT);
		const spriteImg = Utils.createCanvas('', SCENE_SOURCE_WIDTH, SCENE_SOURCE_HEIGHT);
		const transform = [];
		const indices = [];
		const frames = [];
		const sources = {};

		for (let f = 0; f < SCENE_FRAMES; f++) {
			// check if at least one layer has keyframe in current frame
			let hasKeyframe = false;
			for (let layer of layers) {
				if (layer.getClosestKeyFrameAt(f) === f) {
					hasKeyframe = true;
					break;
				}
			}

			transform.push('');

			if (hasKeyframe || f === 0) {
				const ctx = spriteImg.ctx;
				ctx.clearRect(0, 0, SCENE_SOURCE_WIDTH, SCENE_SOURCE_HEIGHT);
				const queue = [];
				for (let layer of layers) {
					queue.push(layer.getImagePromise(f));
				}
				ctx.save();
				srcClip.createBorderPath(ctx);
				ctx.clip();
				for (let layer of (await Promise.all(queue)).reverse()) {
					layer.drawFrame(spriteImg, f);
				}
				ctx.restore();

				frames.push(2);
				const data = spriteImg.el.toDataURL('image/png');
				const key = Utils.getHash(data);
				sources[key] = data;
				indices.push(key);
			} else {
				indices.push('');
				frames.push(0);
			}
		}

		return {
			layers: [{
				sources,
				indices,
				frames,
				transform,
				title: data.name,
				opacity: 100,
				blend: 'normal',
				source_id: '',
				sprites: [],
				id: CanvasLayer.generateId()
			}],
			neighbors: []
		};
	}

}
